/* PL Decals — Gallery page behavior
 * Filter pills, lightbox with keyboard nav.
 * Auto-init on DOMContentLoaded + Shopify customizer events.
 */
(function () {
  "use strict";

  /* ====== Filter ====== */
  function setupFilter() {
    const pills = document.querySelectorAll(".filter-pills .pill");
    const items = document.querySelectorAll(".masonry-item");
    const showingEl = document.getElementById("showing-count");
    if (pills.length === 0 || items.length === 0) return;

    function filter(cat) {
      let visible = 0;
      items.forEach((item) => {
        const cats = item.dataset.cat || "";
        const show = cat === "all" || cats.split(/\s+/).includes(cat);
        item.style.display = show ? "" : "none";
        if (show) visible++;
      });
      if (showingEl) showingEl.textContent = visible;
    }

    pills.forEach((p) => {
      p.addEventListener("click", () => {
        pills.forEach((x) => x.classList.remove("active"));
        p.classList.add("active");
        filter(p.dataset.cat || "all");
      });
    });
  }

  /* ====== Lightbox ====== */
  let currentItems = [];
  let lbIdx = 0;

  function showLb() {
    const item = currentItems[lbIdx];
    if (!item) return;
    const kit = document.getElementById("g-lb-kit");
    const rider = document.getElementById("g-lb-rider");
    const bike = document.getElementById("g-lb-bike");
    const imgWrap = document.getElementById("g-lb-img-wrap");
    const orderBtn = document.getElementById("g-lb-order");
    if (kit) kit.textContent = item.dataset.kit || "";
    if (rider) rider.textContent = item.dataset.rider || "";
    if (bike) bike.textContent = item.dataset.bike || "";
    if (imgWrap) {
      const src = item.querySelector("img");
      imgWrap.innerHTML = src
        ? `<img src="${src.src}" alt="">`
        : '<div class="g-lb-img-ph">📷</div>';
    }
    if (orderBtn) {
      const url = item.dataset.order;
      if (url) {
        orderBtn.href = url;
        orderBtn.style.display = "";
      } else {
        orderBtn.style.display = "none";
      }
    }
  }

  function openLb(el) {
    currentItems = Array.from(
      document.querySelectorAll('.masonry-item:not([style*="none"])')
    );
    lbIdx = currentItems.indexOf(el);
    if (lbIdx < 0) return;
    showLb();
    const lb = document.getElementById("g-lb");
    if (lb) {
      lb.classList.add("open");
      document.body.style.overflow = "hidden";
    }
  }

  function navLb(dir) {
    if (currentItems.length === 0) return;
    lbIdx = (lbIdx + dir + currentItems.length) % currentItems.length;
    showLb();
  }

  function closeLb() {
    const lb = document.getElementById("g-lb");
    if (lb) {
      lb.classList.remove("open");
      document.body.style.overflow = "";
    }
  }

  function setupLightbox() {
    document.querySelectorAll(".masonry-item").forEach((item) => {
      item.addEventListener("click", () => openLb(item));
    });
    const lb = document.getElementById("g-lb");
    if (lb) {
      lb.addEventListener("click", (e) => {
        if (e.target === lb) closeLb();
      });
    }
    const close = document.querySelector(".g-lb-close");
    const prev = document.querySelector(".g-lb-prev");
    const next = document.querySelector(".g-lb-next");
    if (close) close.addEventListener("click", closeLb);
    if (prev) prev.addEventListener("click", () => navLb(-1));
    if (next) next.addEventListener("click", () => navLb(1));

    document.addEventListener("keydown", (e) => {
      const lb = document.getElementById("g-lb");
      if (!lb || !lb.classList.contains("open")) return;
      if (e.key === "Escape") closeLb();
      if (e.key === "ArrowRight") navLb(1);
      if (e.key === "ArrowLeft") navLb(-1);
    });
  }

  /* ====== Init ====== */
  function init() {
    setupFilter();
    setupLightbox();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }

  // Re-init when Customizer reloads a gallery section
  document.addEventListener("shopify:section:load", (e) => {
    if (!e.target) return;
    if (
      e.target.querySelector &&
      (e.target.querySelector(".masonry") ||
        e.target.querySelector(".sub-form") ||
        e.target.querySelector(".filter-pills"))
    ) {
      init();
    }
  });
})();
